import React from 'react';
import Months from './Months';
import AuthStore from '../stores/AuthStore';
import LoginForm from '../components/LoginForm';

class IndexComponent extends React.Component {

  constructor() {
    super();
    this.state = {
      authenticated: AuthStore.isAuthenticated()
    }
  }
  render() {
    return (
      <div>
        { !this.state.authenticated ? (
          <LoginForm/>
        ) : (
          <Months />
        )}
      </div>
    );
  }
}

export default IndexComponent;



// WEBPACK FOOTER //
// ./src/components/Index.js